import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-loader[loading]',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderComponent {
  loading: InputSignal<boolean> = input.required();
}
